<template>
    <div>

        <el-row :gutter="10">
            <el-col :span="4" :xs="24" class="us-form-label">Anrede</el-col>
            <el-col :span="20" :xs="24"><el-select v-model="form.Anrede" placeholder="Bitte auswählen">
            <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"></el-option></el-select></el-col>
        </el-row>

        <el-row :gutter="10">
            <el-col :span="4" :xs="24" class="us-form-label">Name, Vorname*</el-col>
            <el-col :span="20" :xs="24"><el-input v-model="form.Name" name="Name" v-validate="'required'"></el-input></el-col>
        </el-row>

        <el-row :gutter="10">
            <el-col :span="4" :xs="24" class="us-form-label">Straße und Nr.*</el-col>
            <el-col :span="20" :xs="24"><el-input v-model="form.Straße" name="Straße" v-validate="'required'"></el-input></el-col>
        </el-row>

        <el-row :gutter="10">
            <el-col :span="4" :xs="24" class="us-form-label">PLZ/Ort*</el-col>
            <el-col :span="20" :xs="24">
                <el-row style="padding: 0px;" :gutter="10">
                    <el-col :span="6" :xs="24"><el-input v-model="form.PLZ" name="PLZ" v-validate="'required'"></el-input></el-col>
                    <el-col :span="18" :xs="24"><el-input v-model="form.Ort" name="Ort" v-validate="'required'"></el-input></el-col>
                </el-row>
            </el-col>
        </el-row>

        <el-row :gutter="10">
            <el-col :span="4" :xs="24" class="us-form-label">Telefon*</el-col>
            <el-col :span="20" :xs="24"><el-input v-model="form.Telefon" name="Telefon" v-validate="'required'"></el-input></el-col>
        </el-row>

        <el-row :gutter="10">
            <el-col :span="4" :xs="24" class="us-form-label">E-Mail</el-col>
            <el-col :span="20" :xs="24"><el-input v-model="form.Email"></el-input></el-col>
        </el-row>

        <el-row :gutter="10">
            <el-col :span="4" :xs="24" class="us-form-label">Betreff</el-col>
            <el-col :span="20" :xs="24"><el-input v-model="form.Betreff"></el-input></el-col>
        </el-row>

        <el-row :gutter="10">
            <el-col :span="4" :xs="24" class="us-form-label">Nachricht</el-col>
            <el-col :span="20" :xs="24"><el-input type="textarea" :rows="2" v-model="form.Nachricht" placeholder=""></el-input></el-col>
        </el-row>

        <el-row :gutter="10">
            <el-col :span="4" :xs="24" class="us-form-label"><el-checkbox v-model="form.Datenschutz" name="Datenschutz" v-validate="'required:invalidateFalse'"></el-checkbox></el-col>
            <el-col :span="20" :xs="24">
                Ja, ich habe die <a target="_blank" href="#/article/72">Datenschutzerklärung</a> zur Kenntnis genommen und bin damit einverstanden, dass die von mir angegebenen Daten elektronisch erhoben und gespeichert werden. Meine Daten werden dabei nur streng zweckgebunden zur Bearbeitung und
                Beantwortung meiner Anfrage genutzt.
            </el-col>
        </el-row>

        <el-row :gutter="10">
            <el-col :span="4" :xs="24" class="us-form-label">&nbsp;</el-col>
            <el-col :span="20" :xs="24"><el-button type="primary" @click="onSubmit"  style="border:none;">Senden</el-button></el-col>
        </el-row>
    </div>
</template>

<script>
export default {
    data() {
        return {
            options: [{
          value: 'Option1',
          label: 'Frau'
        }, {
          value: 'Option2',
          label: 'Herr'
        }, {
          value: 'Option3',
          label: 'Firma'
        }],
            form: {
                subject: "Kontaktanfrage",
                Name: "",
                Straße: "",
                PLZ: "",
                Ort: "",
                Telefon: "",
                Email: "",
                Betreff: "",
                Nachricht: "",
                Datenschutz: false
            }
        }
    },
    methods: {
        onSubmit() {
            this.$validator.validate().then(result => {
                if (!result) {
                    this.$alert(this.errors.all().join("<br>"), "Fehler", { dangerouslyUseHTMLString: true })
                    return
                }
                let formData = new FormData()
                for (const key in this.form) {
                    formData.append(key, this.form[key])
                }

                fetch("https://lww.de/php/mail_action.php", { method: "POST", body: formData })
                    .then(res => res.json())
                    .then(jsonData => {
                        this.form = {};
                        this.$alert('Vielen Dank für Ihre Nachricht, wir werden uns in Kürze bei Ihnen melden.', "Mail versendet", { dangerouslyUseHTMLString: true })
                    })
                    .catch(error => {
                        this.$alert('Die E-Mail konnte leider nicht versendet werden.', "Fehler", { dangerouslyUseHTMLString: true })
                    return
                    })
            })
        }
    }
}
</script>

<style lang="scss" scoped>
.el-row {
    padding: 10px 0px;
}
.us-form-label {
    display: flex;
    align-items: center;
    justify-content: right;
    height: 40px;
}
.el-button {
    width: 100%;
    background-color: purple;
}
</style>